import { render, staticRenderFns } from "./imageWrapper.vue?vue&type=template&id=3735760e&scoped=true&"
import script from "./imageWrapper.vue?vue&type=script&lang=js&"
export * from "./imageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./imageWrapper.vue?vue&type=style&index=0&id=3735760e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735760e",
  null
  
)

export default component.exports